<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar no-display" flat dense>
        <v-toolbar-title>
          <strong> Combine Course Marks </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense class="no-display">
        <v-col cols="12" sm="2" md="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Select Academic Year"
            outlined
            @change="
              getStd();
              getCombine_course_marks_header();
            "
            persistent-hint
            hint="Please select academic year"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="getStandardCourse()"
            persistent-hint
            hint="Please select standard"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            multiple
            v-model="crs_id"
            item-value="c_id"
            :items="crs_list"
            item-text="course"
            label="Course"
            outlined
            persistent-hint
            hint="Please select course"
          />
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
          <v-icon color="error">*</v-icon>
          <v-text-field
            color="#0F2027"
            dense
            rounded
            required
            v-model="header"
            label="Combine Hearder Name"
            outlined
            persistent-hint
            hint="Please Add Combine Hearder Name"
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="2" md="2" v-if="crs_list != ''">
          <v-icon color="error">*</v-icon>
          <v-text-field
            color="#0F2027"
            dense
            rounded
            required
            v-model="sort_order"
            label="Sort Order"
            type="number"
            outlined
            persistent-hint
            hint="Please Add Sort Order"
          >
          </v-text-field>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="2"
          v-if="sel_ay_data && sel_std_data && crs_id != '' && header"
        >
          <v-btn
            class="mt-6 button"
            @click="combine_marks()"
            :loading="fetch_loader"
            >Add</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="headerlist != ''">
      <v-data-table
        :headers="headers"
        class="elevation-1 mytable"
        dense
        :items="headerlist"
      >
        <template v-slot:[`item.course`]="{ item }">
          <span v-for="(header, index) in item.course" :key="index">
            {{ header }}
            <br />
          </span>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <v-avatar size="5">
            <v-icon
              class="ml-5"
              @click="deleteheader(item.id, item.course_id)"
              color="red"
              title="Delete Combine Course"
              >delete</v-icon
            >
          </v-avatar>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      overlay: false,
      selected: [],
      snackbar: false,
      course_list: [],
      crs_id: [],
      search: "",
      crs_list: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      semester_list: null,
      sem: null,
      fetch_loader: false,
      standard: null,
      division: null,
      course: null,
      org_basic_data: [],
      header: null,
      sort_order: null,
      headerlist: [],
      headers: [
        { text: "Academic Year", value: "academicyear" },
        { text: "Standard", value: "standard" },
        { text: "Sort Order", value: "sort_order" },
        { text: "Combine Course Name", value: "name" },
        { text: "Combined Courses", value: "course" },
        { text: "Delete", value: "delete" },
      ],
    };
  },

  methods: {
    deleteheader(id, course_id) {
      const data = {
        combine_id: id,
        course_id: course_id,
      };
      axios
        .post("/Examination/delete_course_marks_header", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Dleted Successfully...");
            this.getCombine_course_marks_header();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getCombine_course_marks_header() {
      const data = {
        ay: this.sel_ay_data.ay_id,
      };
      axios
        .post("/Examination/getCombine_course_marks_header", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.headerlist = res.data.headerlist;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    combine_marks() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
        header: this.header,
        crs_id: this.crs_id,
        sort_order: this.sort_order,
      };
      axios
        .post("/Examination/combine_course_marks_header", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("#4caf50", "Saved Successfully...");
            this.getCombine_course_marks_header();
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          (this.sel_ay_data = null),
            (this.sel_std_data = null),
            (this.header = null),
            (this.crs_id = []);
          this.sort_order = null;
        });
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    putnull() {
      this.crs_list = [];
      this.crs_id = [];
    },
    getStandardCourse() {
      const data = {
        ay: this.sel_ay_data.ay_id,
        standard: this.sel_std_data.std_id,
      };
      axios
        .post("/Examination/getStandardCourse", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.crs_list = res.data.courses_list;
          }
          if (res.data.flag == "NO") {
            this.showSnackbar(
              "#b71c1c",
              "No courses offered for this standard..."
            ); // show snackbar
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
    },
    getDiv() {
      // this.div_list = ["All"];
      // this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      // this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          //     this.sel_ay_data = res.data.curr_ay;
          this.semester_list = res.data.sem_list;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
.btn-css {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #fff !important;
  text-decoration: underline;
  color: #0f2027 !important;
  text-align: left;
}

.btn-css:hover {
  outline: 0 !important;
  outline-offset: 0 !important;
  background-image: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  background-color: #ffff !important;
  color: #0f2027 !important;
  text-decoration: underline;
  text-align: left;
}
.t-row {
  padding: 1rem i !important;
}

.delete-avatar {
  transition: 0.3s;
  border: 1px solid red;
  margin: 0.2rem !important;
}
.delete-avatar:hover {
  background-color: transparent;
}
.delete-v-icon {
  padding-left: 8px;
  padding-top: 1px;
  font-size: 15px;
}
.delete-v-icon:hover {
  color: white;
}
.v-dialogss {
  bottom: 880;
  right: 0;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }
  table,
  td,
  tr {
    break-inside: avoid-page;
  }
  img {
    width: 100% !important;
  }
  body,
  tr,
  th,
  td {
    font-size: small !important;
    font-weight: bold !important;
  }
  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
  }
  v-card {
    border: none !important;
  }
  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 15.5in 15.5in;
  }
  table,
  td,
  tr,
  th {
    text-align: center !important;
    margin-top: none;
    padding: none !important;
    font-weight: bold !important;
    border-bottom: 1px solid black;
    border: 1px solid black;
  }
}
</style>
